export const refreshMixin = {
    data() {
        return {
            isRefreshing: false,
        };
    },
    methods: {
        handleRefreshClick(tabIndex) {
            if (this.isRefreshing) return;
            if (typeof this.onRefresh !== 'function') {
                return;
            }
            this.isRefreshing = true;
            Promise.resolve(this.onRefresh(tabIndex))
                .finally(() => {
                    this.isRefreshing = false;
                });
        },
    },
};
